import styled, { keyframes } from 'styled-components';
import { spacing, colors } from '@izettle/otto';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const spinnerSizes = {
  auto: "1em",
  large: spacing.xLarge,
  normal: spacing.large,
  small: spacing.small,
  xSmall: spacing.xSmall
};
const fillColors = {
  ...colors.spinner,
  white: colors.icon.inverted,
  highlight: colors.spinner.highlight
};
const getSize = _ref => {
  let {
    size
  } = _ref;
  return spinnerSizes[size ?? "normal"];
};
const speed = "0.8s";
const thickness = "2px";
const getFillColor = _ref2 => {
  let {
    color
  } = _ref2;
  return fillColors[color ?? "mint"];
};
const SpinnerSimple = /*#__PURE__*/styled.i.withConfig({
  displayName: "spinner-simple__SpinnerSimple",
  componentId: "zettle__sc-1kgamp2-0"
})(["animation:", " ", " infinite linear;position:relative;display:block;width:", ";height:", ";flex-shrink:0;border:", " solid ", ";border-top-color:transparent !important;background-color:transparent;border-radius:50%;"], spin, speed, getSize, getSize, thickness, getFillColor);

export { SpinnerSimple, spinnerSizes };
//# sourceMappingURL=index.js.map
